import React from 'react'

export const MembershipInternal = () => (
  <path d='M15.167 19.1641V3.16406C15.167 2.63363 14.9563 2.12492 14.5812 1.74985C14.2061 1.37478 13.6974 1.16406 13.167 1.16406H9.16699C8.63656 1.16406 8.12785 1.37478 7.75278 1.74985C7.37771 2.12492 7.16699 2.63363 7.16699 3.16406V19.1641M3.16699 5.16406H19.167C20.2716 5.16406 21.167 6.05949 21.167 7.16406V17.1641C21.167 18.2686 20.2716 19.1641 19.167 19.1641H3.16699C2.06242 19.1641 1.16699 18.2686 1.16699 17.1641V7.16406C1.16699 6.05949 2.06242 5.16406 3.16699 5.16406Z' />
)
